import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react';
import { useGT } from 'gt-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function EmailToggleButton({
  isExpanded,
  onToggle,
  className,
}: {
  isExpanded: boolean;
  onToggle: () => void;
  className?: string;
}) {
  const gt = useGT();
  const Icon = isExpanded ? CaretUpIcon : CaretDownIcon;
  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn('h-6 w-6 p-0', className)}
      aria-label={
        isExpanded
          ? gt('Collapse email', { context: 'collapse expanded email' })
          : gt('Expand email', { context: 'expand collapsed email' })
      }
      aria-expanded={isExpanded}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      <Icon className="h-4 w-4" />
    </Button>
  );
}
